/**
 * @file Accordion
 */
'use strict';

/**
 * @classname Accordion
 * @classdesc Accordion
 */
export default class Accordion {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._$target = $(this._$e.attr('data-target'));
		this._$e.on('click', () => this.onClick());
		if (this._$e.data('is-search')) this.checkIsSearch();
		if (this._$e.data('is-default-open')) {
			this._$target.slideDown(0);
			this._$e.addClass('open').find('i').removeClass('closed').addClass('open');
			this._$e.find('span').text('閉じる');
		}
	}


	/**
	 * 検索画面かどうか確認し、検索画面でクエリパラメータを持っていたら
	 * #search-items-wrap を閉じる
	 *
	 * @memberof Accordion
	 * @return {undefined}
	 */
	checkIsSearch() {
		console.log(`${this.constructor.name}.checkIsSearch`);
		if (location.href.includes('?')) {
			console.log(`'#search-items-wrap' is closed because the page path has query parameters.`);
			this._$target.slideUp(0);
			this._$e.removeClass('open').find('i').removeClass('open').addClass('closed');
			this._$e.find('span').text('開く');
			$('#output-options-wrap').slideDown(0);
		}else{
			this._$target.slideDown(0);
			this._$e.addClass('open').find('i').removeClass('closed').addClass('open');
			this._$e.find('span').text('閉じる');
			$('#output-options-wrap').slideUp(0);
		}
	}


	/**
	 * クリックのコールバック
	 *
	 * @memberof Accordion
	 * @return {undefined}
	 */
	onClick() {
		console.log(`${this.constructor.name}.onClick`);
		if(this._$e.hasClass('open')){
			this._$target.slideUp();
			this._$e.removeClass('open').find('i').removeClass('open').addClass('closed');
			this._$e.find('span:not(.ignore-to-edit-by-accordion)').text('開く');
		}else{
			this._$target.slideDown();
			this._$e.addClass('open').find('i').removeClass('closed').addClass('open');
			this._$e.find('span:not(.ignore-to-edit-by-accordion)').text('閉じる');
		}
	}
}
